export const LSA_SET_STANDARD = 'standard'

export const LSA_SET_CHOICES = [
  { value: LSA_SET_STANDARD, label: 'Standard' },
  { value: 'upfront', label: 'Payment Upfront' },
  { value: 'upfrontChargeName', label: 'Payment Upfront with a charge name' },
]
